import EditDishModal from './EditDishModal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  changeCount,
  changeSpecialRequest,
  createNew,
  edit,
  startEditing,
  toggleChoice,
} from '../../stateManagement/engine/actions/EditDishActions';
import { cartUpsert } from '../../stateManagement/engine/actions/OrderActions';
import { hideModal } from '../../stateManagement/engine/actions/SessionActions';
import { deliveryTypeSelector } from '../../stateManagement/engine/selectors/deliveryTypeSelector';

function mapStateToProps(state, ownProps) {
  return {
    orderItem: state.editDish.orderItem,
    cartIndex: state.editDish.cartIndex,
    itemsHash: state.session.itemsHash,
    locale: state.session.organization.locale,
    currency: state.session.organization.currency,
    deliveryType: deliveryTypeSelector(state),
    simplifiedMenu: state.session.simplifiedMenu,
    ...ownProps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createNew,
      edit,
      toggleChoice,
      changeSpecialRequest,
      changeCount,
      startEditing,
      cartUpsert,
      hideModal,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditDishModal);
